// Regional classification i18n catalog (PRD §4.9) — en-US.
// Translated from the pt-BR source (official MG decree annexes + IGAM ordinance).
export const regionalClassificationCatalogEnUS = {
  "norms": {
    "mgIndustry": "MG Decree No. 48,140/2021 - Dams for disposal of industry waste or tailings",
    "mgMining": "MG Decree No. 48,140/2021 - Dams for disposal of mining waste or tailings",
    "mgWater": "MG Decree No. 48,140/2021 - Dams for water accumulation associated with industrial or mining processes",
    "igam": "IGAM"
  },
  "mgIndustry": {
    "sections": {
      "cri": { "label": "CRI", "subtitle": "1 - Risk classification" },
      "pda": { "label": "PDA", "subtitle": "2 - Potential environmental damage" }
    },
    "grades": {
      "ct": "1.1 - Technical characteristics - CT",
      "ec": "1.2 - Conservation state - EC",
      "psb": "1.3 - Dam safety plan - PSB",
      "pda": "2 - Classification by potential environmental damage - PDA"
    },
    "columns": {
      "ctA": "Height",
      "ctB": "Length",
      "ctC": "Design flow",
      "ctD": "Construction method",
      "ctE": "Monitoring instrumentation",
      "ecF": "Reliability of the spillway structures",
      "ecG": "Seepage",
      "ecH": "Deformations and settlements",
      "ecI": "Deterioration of slopes / faces",
      "psbJ": "Project documentation",
      "psbK": "Organizational structure and qualification of the professionals in the dam safety team",
      "psbL": "Procedure manuals for safety inspections and monitoring",
      "psbM": "Emergency Action Plan – EAP (when required by the regulatory body)",
      "psbN": "Inspection and instrumentation monitoring reports and Safety Analysis",
      "pdaA": "Total reservoir volume",
      "pdaB": "Existence of population downstream",
      "pdaC": "Environmental impact",
      "pdaD": "Socioeconomic impact"
    },
    "options": {
      "ctA": {
        "score0": "Height ≤ 10m",
        "score1": "10m < Height < 30m",
        "score4": "30m ≤ Height ≤ 60m",
        "score7": "Height > 60m"
      },
      "ctB": {
        "score0": "Length ≤ 50m",
        "score1": "50m < Length < 200m",
        "score2": "200 ≤ Length ≤ 600m",
        "score3": "Length > 600m"
      },
      "ctC": {
        "score0": "PMF (Probable Maximum Flood) or 10,000-year flood",
        "score2": "1,000-year flood",
        "score5": "Return period = 500 years",
        "score10": "Return period under 500 years or unknown / unreliable study"
      },
      "ctD": {
        "score1": "Single stage",
        "score3": "Raised structure"
      },
      "ctE": {
        "score0": "Instrumentation exists in accordance with the technical project, or monitoring instrumentation does not apply",
        "score2": "Instrumentation exists not in accordance with the project, but instruments are being installed to comply with the project",
        "score6": "Instrumentation exists not in accordance with the project, with no installation of instruments to comply with the project",
        "score8": "Dam not instrumented, in disagreement with the project"
      },
      "ecF": {
        "score0": "Civil structures well maintained and in normal operation / dam with no need for spillway structures",
        "score3": "Structures with identified problems and corrective measures being implemented",
        "score6": "Structures with identified problems and no implementation of the necessary corrective measures",
        "score10": "Structures with identified problems, with reduced spillway capacity and no corrective measures"
      },
      "ecG": {
        "score0": "Seepage fully controlled by the drainage system",
        "score3": "Moisture or seepage in downstream areas, faces, slopes and abutments, stable and monitored",
        "score6": "Moisture or seepage in downstream areas, faces, slopes or abutments without implementation of the necessary corrective measures",
        "score10": "Seepage in downstream areas with material transport or increasing flow or infiltration of the contained material, with potential to compromise the safety of the structure"
      },
      "ecH": {
        "score0": "No deformations and settlements with potential to compromise the safety of the structure",
        "score2": "Existence of cracks and subsidence with corrective measures being implemented",
        "score6": "Existence of cracks and subsidence without implementation of the necessary corrective measures",
        "score10": "Existence of cracks, subsidence or slides, with potential to compromise the safety of the structure"
      },
      "ecI": {
        "score0": "No deterioration of slopes and faces",
        "score2": "Failures in the protection of slopes and faces, presence of shrub vegetation",
        "score6": "Surface erosion, exposed rebar, presence of arboreal vegetation, without implementation of the necessary corrective measures",
        "score10": "Sharp depressions in the slopes, slides, deep erosion grooves, with potential to compromise the safety of the structure"
      },
      "psbJ": {
        "score0": "Executive and \"as-built\" project",
        "score2": "Executive or \"as-built\" project",
        "score3": "\"As-is\" project",
        "score5": "Basic project",
        "score8": "Conceptual project",
        "score10": "No project documentation"
      },
      "psbK": {
        "score0": "Has an administrative unit with a qualified technical professional responsible for dam safety",
        "score1": "Has a qualified technical professional (in-house or contracted) responsible for dam safety",
        "score3": "Has an administrative unit without a qualified technical professional responsible for dam safety",
        "score6": "Has neither an administrative unit nor a qualified technical professional responsible for dam safety"
      },
      "psbL": {
        "score0": "Has procedure manuals for inspection, monitoring and operation",
        "score2": "Has only a monitoring procedures manual",
        "score4": "Has only an inspection procedures manual",
        "score8": "Has no formal manuals or procedures for monitoring and inspections"
      },
      "psbM": {
        "score0": "Has an EAP",
        "score2": "Has no EAP (not required by the regulatory body)",
        "score4": "EAP under preparation",
        "score8": "Has no EAP (when required by the regulatory body)"
      },
      "psbN": {
        "score0": "Regularly issues inspection and monitoring reports based on instrumentation and Safety Audit",
        "score2": "Regularly issues only Safety Audit reports",
        "score4": "Regularly issues only inspection and monitoring reports",
        "score6": "Regularly issues only visual inspection reports",
        "score8": "Does not regularly issue inspection and monitoring reports and Safety Audit"
      },
      "pdaA": {
        "score1": "Very small: ≤ 1 million m³",
        "score2": "Small: 1 million to 5 million m³",
        "score3": "Medium: 5 million to 25 million m³",
        "score4": "Large: 25 million to 50 million m³",
        "score5": "Very large: ≥ 50 million m³"
      },
      "pdaB": {
        "score0": "Nonexistent — there are no permanent/resident or temporary/transient people in the area affected downstream of the dam",
        "score3": "Infrequent — no people permanently occupy the affected area downstream of the dam, but there is a local access road",
        "score5": "Frequent — no people permanently occupy the affected area downstream of the dam, but there is a municipal, state or federal highway or another site and/or development of occasional presence of people who could be affected",
        "score10": "Existent — people permanently occupy the area affected downstream of the dam, therefore human lives could be affected"
      },
      "pdaC": {
        "score0": "Insignificant — affected area downstream of the dam is fully stripped of its natural conditions and the structure stores only Class II waste, per ABNT NBR 10,004",
        "score2": "Slightly significant — affected area downstream of the dam does not present relevant environmental interest areas or areas protected by specific legislation, excluding PPAs, and stores only Class II waste, per ABNT NBR 10,004",
        "score4": "Significant — affected area downstream of the dam presents relevant environmental interest areas or areas protected by specific legislation, excluding PPAs, and stores only Class II waste, per ABNT NBR 10,004",
        "score10": "Very significant — dam stores tailings or solid waste classified as Class I – Hazardous, per ABNT NBR 10,004"
      },
      "pdaD": {
        "score0": "Nonexistent — there are no facilities in the area affected downstream of the dam",
        "score1": "Low — there is a small concentration of residential, agricultural, industrial facilities or infrastructure of socioeconomic-cultural relevance in the affected area downstream of the dam",
        "score3": "Medium — there is a moderate concentration of residential, agricultural, industrial facilities or infrastructure of socioeconomic-cultural relevance in the affected area downstream of the dam",
        "score5": "High — there is a high concentration of residential, agricultural, industrial facilities or infrastructure of socioeconomic-cultural relevance in the affected area downstream of the dam"
      }
    }
  },
  "mgMining": {
    "sections": {
      "cri": { "label": "CRI", "subtitle": "1 - Risk classification" },
      "pda": { "label": "PDA", "subtitle": "2 - Potential environmental damage" }
    },
    "grades": {
      "ct": "1.1 - Technical characteristics - CT",
      "ec": "1.2 - Conservation state - EC",
      "psb": "1.3 - Dam safety plan - PSB",
      "pda": "2 - Classification by potential environmental damage - PDA"
    },
    "columns": {
      "ctA": "Height",
      "ctB": "Length",
      "ctC": "Design flow",
      "ctD": "Construction method",
      "ctE": "Monitoring instrumentation",
      "ecF": "Reliability of the spillway structures",
      "ecG": "Seepage",
      "ecH": "Deformations and settlements",
      "ecI": "Deterioration of slopes / faces",
      "psbJ": "Project documentation",
      "psbK": "Organizational structure and qualification of the professionals in the dam safety team",
      "psbL": "Procedure manuals for safety inspections and monitoring",
      "psbM": "Emergency Action Plan – EAP (when required by the regulatory body)",
      "psbN": "Inspection and instrumentation monitoring reports and Safety Analysis",
      "pdaA": "Total reservoir volume",
      "pdaB": "Existence of population downstream",
      "pdaC": "Environmental impact",
      "pdaD": "Socioeconomic impact"
    },
    "options": {
      "ctA": {
        "score0": "Height ≤ 10m",
        "score1": "10m < Height < 30m",
        "score4": "30m ≤ Height ≤ 60m",
        "score7": "Height > 60m"
      },
      "ctB": {
        "score0": "Length ≤ 50m",
        "score1": "50m < Length < 200m",
        "score2": "200 ≤ Length ≤ 600m",
        "score3": "Length > 600m"
      },
      "ctC": {
        "score0": "PMF (Probable Maximum Flood) or 10,000-year flood",
        "score2": "1,000-year flood",
        "score5": "Return period = 500 years",
        "score10": "Return period under 500 years or unknown / unreliable study"
      },
      "ctD": {
        "score0": "Single stage",
        "score2": "Downstream raising",
        "score5": "Centerline raising",
        "score10": "Upstream raising or unknown, or already raised upstream during the structure's life cycle"
      },
      "ctE": {
        "score0": "Instrumentation exists in accordance with the technical project",
        "score2": "Instrumentation exists not in accordance with the project, but instruments are being installed to comply with the project",
        "score6": "Instrumentation exists not in accordance with the project, with no installation of instruments to comply with the project",
        "score8": "Dam not instrumented, in disagreement with the project"
      },
      "ecF": {
        "score0": "Civil structures well maintained and in normal operation / dam with no need for spillway structures",
        "score3": "Structures with identified problems and corrective measures being implemented",
        "score6": "Structures with identified problems and no implementation of the necessary corrective measures",
        "score10": "Structures with identified problems, with reduced spillway capacity and no corrective measures"
      },
      "ecG": {
        "score0": "Seepage fully controlled by the drainage system",
        "score3": "Moisture or seepage in downstream areas, faces, slopes and abutments, stable and monitored",
        "score6": "Moisture or seepage in downstream areas, faces, slopes or abutments without implementation of the necessary corrective measures",
        "score10": "Seepage in downstream areas with material transport or increasing flow or infiltration of the contained material, with potential to compromise the safety of the structure"
      },
      "ecH": {
        "score0": "No deformations and settlements with potential to compromise the safety of the structure",
        "score2": "Existence of cracks and subsidence with corrective measures being implemented",
        "score6": "Existence of cracks and subsidence without implementation of the necessary corrective measures",
        "score10": "Existence of cracks, subsidence or slides, with potential to compromise the safety of the structure"
      },
      "ecI": {
        "score0": "No deterioration of slopes and faces",
        "score2": "Failures in the protection of slopes and faces, presence of shrub vegetation",
        "score6": "Surface erosion, exposed rebar, presence of arboreal vegetation, without implementation of the necessary corrective measures",
        "score10": "Sharp depressions in the slopes, slides, deep erosion grooves, with potential to compromise the safety of the structure"
      },
      "psbJ": {
        "score0": "Executive and \"as-built\" project",
        "score2": "Executive or \"as-built\" project",
        "score3": "\"As-is\" project",
        "score5": "Basic project",
        "score8": "Conceptual project",
        "score10": "No project documentation"
      },
      "psbK": {
        "score0": "Has an administrative unit with a qualified technical professional responsible for dam safety",
        "score1": "Has a qualified technical professional (in-house or contracted) responsible for dam safety",
        "score3": "Has an administrative unit without a qualified technical professional responsible for dam safety",
        "score6": "Has neither an administrative unit nor a qualified technical professional responsible for dam safety"
      },
      "psbL": {
        "score0": "Has procedure manuals for inspection, monitoring and operation",
        "score2": "Has only a monitoring procedures manual",
        "score4": "Has only an inspection procedures manual",
        "score8": "Has no formal manuals or procedures for monitoring and inspections"
      },
      "psbM": {
        "score0": "Has an EAP",
        "score2": "Has no EAP (not required by the regulatory body)",
        "score4": "EAP under preparation",
        "score8": "Has no EAP (when required by the regulatory body)"
      },
      "psbN": {
        "score0": "Regularly issues inspection and monitoring reports based on instrumentation and Safety Analysis",
        "score2": "Regularly issues only Safety Analysis reports",
        "score4": "Regularly issues only inspection and monitoring reports",
        "score6": "Regularly issues only visual inspection reports",
        "score8": "Does not regularly issue inspection and monitoring reports and Safety Analysis"
      },
      "pdaA": {
        "score1": "Very small: ≤ 1 million m³",
        "score2": "Small: 1 million to 5 million m³",
        "score3": "Medium: 5 million to 25 million m³",
        "score4": "Large: 25 million to 50 million m³",
        "score5": "Very large: ≥ 50 million m³"
      },
      "pdaB": {
        "score0": "Nonexistent — there are no permanent/resident or temporary/transient people in the area affected downstream of the dam",
        "score3": "Infrequent — no people permanently occupy the affected area downstream of the dam, but there is a local access road",
        "score5": "Frequent — no people permanently occupy the affected area downstream of the dam, but there is a municipal, state or federal highway or another site and/or development of occasional presence of people who could be affected",
        "score10": "Existent — people permanently occupy the area affected downstream of the dam, therefore human lives could be affected"
      },
      "pdaC": {
        "score0": "Insignificant — affected area downstream of the dam is fully stripped of its natural conditions and the structure stores only Class II B – Inert waste, per ABNT NBR 10,004",
        "score2": "Slightly significant — affected area downstream of the dam does not present relevant environmental interest areas or areas protected by specific legislation, excluding PPAs, and stores only Class II B – Inert waste, per ABNT NBR 10,004",
        "score6": "Significant — affected area downstream of the dam presents relevant environmental interest areas or areas protected by specific legislation, excluding PPAs, and stores only Class II B – Inert waste, per ABNT NBR 10,004",
        "score8": "Very significant — dam stores tailings or solid waste classified as Class II A – Non-Inert, per ABNT NBR 10,004",
        "score10": "Very significant aggravated — dam stores tailings or solid waste classified as Class I – Hazardous, per ABNT NBR 10,004"
      },
      "pdaD": {
        "score0": "Nonexistent — there are no facilities in the area affected downstream of the dam",
        "score1": "Low — there is a small concentration of residential, agricultural, industrial facilities or infrastructure of socioeconomic-cultural relevance in the affected area downstream of the dam",
        "score3": "Medium — there is a moderate concentration of residential, agricultural, industrial facilities or infrastructure of socioeconomic-cultural relevance in the affected area downstream of the dam",
        "score5": "High — there is a high concentration of residential, agricultural, industrial facilities or infrastructure of socioeconomic-cultural relevance in the affected area downstream of the dam"
      }
    }
  },
  "mgWater": {
    "sections": {
      "cri": { "label": "CRI", "subtitle": "1 - Risk classification" },
      "pda": { "label": "PDA", "subtitle": "2 - Potential environmental damage" }
    },
    "grades": {
      "ct": "1.1 - Technical characteristics - CT",
      "ec": "1.2 - Conservation state - EC",
      "psb": "1.3 - Dam safety plan - PSB",
      "pda": "2 - Classification by potential environmental damage - PDA"
    },
    "columns": {
      "ctA": "Height",
      "ctB": "Length",
      "ctC": "Dam type by construction material",
      "ctD": "Foundation type",
      "ctE": "Dam age",
      "ctF": "Design flow",
      "ecG": "Reliability of the spillway structures",
      "ecH": "Reliability of the intake structures",
      "ecI": "Seepage",
      "ecJ": "Deformations and settlements",
      "ecK": "Deterioration of slopes / faces",
      "psbL": "Existence of project documentation",
      "psbM": "Organizational structure and technical qualification of the professionals in the dam safety team",
      "psbN": "Procedures and routines for safety inspections and monitoring",
      "psbO": "Operating rule for the dam discharge devices",
      "psbP": "Safety inspection reports with analysis and interpretation",
      "pdaA": "Total reservoir volume",
      "pdaB": "Potential for loss of human lives",
      "pdaC": "Environmental impact",
      "pdaD": "Socioeconomic impact"
    },
    "options": {
      "ctA": {
        "score0": "Height ≤ 10m",
        "score1": "10m < Height < 30m",
        "score2": "30m ≤ Height ≤ 60m",
        "score3": "Height > 60m"
      },
      "ctB": {
        "score2": "Length ≤ 200m",
        "score3": "Length > 200m"
      },
      "ctC": {
        "score1": "Conventional concrete",
        "score2": "Stone masonry / Cyclopean concrete / Roller-compacted concrete – RCC",
        "score3": "Homogeneous earth / Rockfill / Earth-rockfill"
      },
      "ctD": {
        "score1": "Sound rock",
        "score2": "Hard weathered rock with treatment",
        "score3": "Weathered rock without treatment / Fractured weathered rock with treatment",
        "score4": "Soft weathered rock / Saprolite / Compact soil",
        "score5": "Residual soil / alluvium"
      },
      "ctE": {
        "score1": "Between 30 and 50 years",
        "score2": "Between 10 and 30 years",
        "score3": "Between 5 and 10 years",
        "score4": "< 5 years or > 50 years or no information"
      },
      "ctF": {
        "score3": "PMF (Probable Maximum Flood) or 10,000-year flood",
        "score5": "1,000-year flood",
        "score8": "Return period = 500 years",
        "score10": "Return period < 500 years or unknown / unreliable study"
      },
      "ecG": {
        "score0": "Civil and hydro-electromechanical structures in full operation / approach or restitution channels or spillway (free-overflow weir type) unobstructed",
        "score4": "Civil and hydro-electromechanical structures ready for operation, but without emergency power supply sources / channels or spillway (free-overflow weir type) with erosion or obstructions, but without risks to the overflow structure",
        "score7": "Compromised civil structures or hydro-electromechanical devices with identified problems, with reduced flow capacity and corrective measures being implemented / channels or spillway (free-overflow weir type) with erosion and/or partially obstructed, with risk of compromising the overflow structure",
        "score10": "Compromised civil structures or hydro-electromechanical devices with identified problems, with reduced flow capacity and no corrective measures / channels or spillway (free-overflow weir type) obstructed or with damaged structures"
      },
      "ecH": {
        "score0": "Civil structures and hydro-electromechanical devices in adequate maintenance and operating conditions",
        "score4": "Compromised civil structures or hydro-electromechanical devices with identified problems, with reduced flow capacity and corrective measures being implemented",
        "score6": "Compromised civil structures or hydro-electromechanical devices with identified problems, with reduced flow capacity and no corrective measures"
      },
      "ecI": {
        "score0": "Seepage fully controlled by the drainage system",
        "score3": "Moisture or seepage in downstream areas, faces, slopes or abutments stabilized and/or monitored",
        "score5": "Moisture or seepage in downstream areas, faces, slopes or abutments without treatment or in the diagnosis phase",
        "score8": "Seepage in downstream areas, slopes or abutments with material transport or with increasing flow"
      },
      "ecJ": {
        "score0": "Nonexistent",
        "score1": "Existence of cracks and subsidence of small extent and null impact",
        "score5": "Existence of cracks and subsidence of considerable impact requiring additional studies or monitoring",
        "score8": "Existence of significant cracks, subsidence or slides, with potential to compromise safety"
      },
      "ecK": {
        "score0": "Nonexistent",
        "score1": "Failures in the protection of slopes and faces, presence of shrubs of small extent and null impact",
        "score5": "Surface erosion, exposed rebar, widespread vegetation growth, requiring monitoring or corrective action",
        "score7": "Sharp depressions in the slopes, slides, deep erosion grooves, with potential to compromise safety"
      },
      "psbL": {
        "score0": "Executive and \"as-built\" project",
        "score2": "Executive or \"as-built\" project",
        "score4": "Basic project",
        "score6": "Preliminary or conceptual project",
        "score8": "No project documentation"
      },
      "psbM": {
        "score0": "Has an organizational structure with a technician responsible for dam safety",
        "score4": "Has a technician responsible for dam safety",
        "score8": "Has neither an organizational structure nor a technical lead responsible for dam safety"
      },
      "psbN": {
        "score0": "Has and applies inspection and monitoring procedures",
        "score3": "Has and applies only inspection procedures",
        "score5": "Has but does not apply inspection and monitoring procedures",
        "score6": "Has no and does not apply procedures for monitoring and inspections"
      },
      "psbO": {
        "score0": "Yes or free-overflow weir type spillway",
        "score6": "No"
      },
      "psbP": {
        "score0": "Regularly issues the reports",
        "score3": "Issues the reports without periodicity",
        "score5": "Does not issue the reports"
      },
      "pdaA": {
        "score0": "Very small: ≤ 1 million m³",
        "score1": "Small: 1 million to 5 million m³",
        "score2": "Medium: 5 million to 25 million m³",
        "score3": "Large: 25 million to 50 million m³",
        "score4": "Very large: ≥ 50 million m³"
      },
      "pdaB": {
        "score0": "Nonexistent — there are no permanent/resident or temporary/transient people in the area affected downstream of the dam",
        "score4": "Infrequent — no people permanently occupy the affected area downstream of the dam, but there is a local access road",
        "score8": "Frequent — no people permanently occupy the affected area downstream of the dam, but there is a municipal, state or federal highway or another site and/or development of occasional presence of people who could be affected",
        "score12": "Existent — people permanently occupy the area affected downstream of the dam, therefore human lives could be affected"
      },
      "pdaC": {
        "score1": "Slightly significant — affected area of the dam does not represent an environmental interest area, areas protected by specific legislation, or is fully stripped of its natural conditions",
        "score2": "Significant — the affected area includes sustainable-use protection areas (EPA, FLONA, RESEX, etc.) or is an environmental interest area and is slightly stripped of its natural conditions",
        "score5": "Very significant — the affected area includes full-protection areas (ESEC, PARNA, REBIO, etc.), including Indigenous Lands, or is of great environmental interest in its natural state"
      },
      "pdaD": {
        "score0": "Nonexistent — there are no facilities or navigation services in the area affected by a dam accident",
        "score1": "Low — there are 1 to 5 residential and commercial, agricultural, industrial facilities or infrastructure in the affected area of the dam",
        "score3": "Medium — there are more than 5 up to 30 residential and commercial, agricultural, industrial facilities or infrastructure in the affected area of the dam",
        "score8": "High — large concentration of residential and commercial, agricultural, industrial facilities, infrastructure and leisure and tourism services in the affected area of the dam, or port facilities or navigation services"
      }
    }
  },
  "igam": {
    "sections": {
      "cri": { "label": "CRI", "subtitle": "1 - Risk classification" },
      "dpa": { "label": "DPA", "subtitle": "2 - Associated potential damage" }
    },
    "grades": {
      "ct": "1.1 - Technical characteristics - CT",
      "ec": "1.2 - Conservation state - EC",
      "psb": "1.3 - Dam safety plan - PS",
      "dpa": "2 - Classification by associated potential damage - DPA"
    },
    "columns": {
      "ctA": "Height",
      "ctB": "Length",
      "ctC": "Dam type by construction material",
      "ctD": "Foundation type",
      "ctE": "Dam age",
      "ctF": "Design flow",
      "ecG": "Reliability of the spillway structures",
      "ecH": "Reliability of the intake structures",
      "ecI": "Seepage",
      "ecJ": "Deformations and settlements",
      "ecK": "Deterioration of slopes / faces",
      "ecL": "Lock",
      "psbM": "Existence of project documentation",
      "psbN": "Organizational structure and technical qualification of the professionals in the dam safety team",
      "psbO": "Procedures and routines for safety inspections and monitoring",
      "psbP": "Operating rule for the dam discharge devices",
      "psbQ": "Safety inspection reports with analysis and interpretation",
      "dpaA": "Total reservoir volume",
      "dpaB": "Potential for loss of human lives",
      "dpaC": "Environmental impact",
      "dpaD": "Socioeconomic impact"
    },
    "options": {
      "ctA": {
        "score0": "Height ≤ 15m",
        "score1": "15m < Height < 30m",
        "score2": "30m ≤ Height ≤ 60m",
        "score3": "Height > 60m"
      },
      "ctB": {
        "score2": "Length ≤ 200m",
        "score3": "Length > 200m"
      },
      "ctC": {
        "score1": "Conventional concrete",
        "score2": "Stone masonry / cyclopean concrete / roller-compacted concrete – RCC",
        "score3": "Homogeneous earth / rockfill / earth-rockfill"
      },
      "ctD": {
        "score1": "Sound rock",
        "score2": "Hard weathered rock with treatment",
        "score3": "Weathered rock without treatment / Fractured weathered rock with treatment",
        "score4": "Soft weathered rock / saprolite / compact soil",
        "score5": "Residual soil / alluvium"
      },
      "ctE": {
        "score1": "Between 30 and 50 years",
        "score2": "Between 10 and 30 years",
        "score3": "Between 5 and 10 years",
        "score4": "< 5 years or > 50 years or no information"
      },
      "ctF": {
        "score3": "PMF (Probable Maximum Flood) or 10,000-year flood",
        "score5": "1,000-year flood",
        "score8": "Return period = 500 years",
        "score10": "Return period < 500 years or unknown / unreliable study"
      },
      "ecG": {
        "score0": "Civil and hydro-electromechanical structures in full operation / approach or restitution channels or spillway (free-overflow weir type) unobstructed",
        "score4": "Civil and hydro-electromechanical structures ready for operation, but without emergency power supply sources / channels or spillway (free-overflow weir type) with erosion or obstructions, but without risks to the overflow structure",
        "score7": "Compromised civil structures or hydro-electromechanical devices with identified problems, with reduced flow capacity and corrective measures being implemented / channels or spillway (free-overflow weir type) with erosion and/or partially obstructed, with risk of compromising the overflow structure",
        "score10": "Compromised civil structures or hydro-electromechanical devices with identified problems, with reduced flow capacity and no corrective measures / channels or spillway (free-overflow weir type) obstructed or with damaged structures"
      },
      "ecH": {
        "score0": "Civil structures and hydro-electromechanical devices in adequate maintenance and operating conditions",
        "score4": "Compromised civil structures or hydro-electromechanical devices with identified problems, with reduced flow capacity and corrective measures being implemented",
        "score6": "Compromised civil structures or hydro-electromechanical devices with identified problems, with reduced flow capacity and no corrective measures"
      },
      "ecI": {
        "score0": "Seepage fully controlled by the drainage system",
        "score3": "Moisture or seepage in downstream areas, faces, slopes or abutments stabilized and/or monitored",
        "score5": "Moisture or seepage in downstream areas, faces, slopes or abutments without treatment or in the diagnosis phase",
        "score8": "Seepage in downstream areas, slopes or abutments with material transport or with increasing flow"
      },
      "ecJ": {
        "score0": "Nonexistent",
        "score1": "Existence of cracks and subsidence of small extent and null impact",
        "score5": "Existence of cracks and subsidence of considerable impact requiring additional studies or monitoring",
        "score8": "Existence of significant cracks, subsidence or slides, with potential to compromise safety"
      },
      "ecK": {
        "score0": "Nonexistent",
        "score1": "Failures in the protection of slopes and faces, presence of shrubs of small extent and null impact",
        "score5": "Surface erosion, exposed rebar, widespread vegetation growth, requiring monitoring or corrective action",
        "score7": "Sharp depressions in the slopes, slides, deep erosion grooves, with potential to compromise safety"
      },
      "ecL": {
        "score0": "Has no lock",
        "score1": "Civil and hydro-electromechanical structures well maintained and operating",
        "score2": "Compromised civil structures or hydro-electromechanical devices with identified problems and corrective measures being implemented",
        "score4": "Compromised civil structures or hydro-electromechanical devices with identified problems and no corrective measures"
      },
      "psbM": {
        "score0": "Executive and \"as-built\" project",
        "score2": "Executive or \"as-built\" project",
        "score4": "Basic project",
        "score6": "Preliminary or conceptual project",
        "score8": "No project documentation"
      },
      "psbN": {
        "score0": "Has an organizational structure with a technician responsible for dam safety",
        "score4": "Has a technician responsible for dam safety",
        "score8": "Has neither an organizational structure nor a technical lead responsible for dam safety"
      },
      "psbO": {
        "score0": "Has and applies inspection and monitoring procedures",
        "score3": "Has and applies only inspection procedures",
        "score5": "Has but does not apply inspection and monitoring procedures",
        "score6": "Has no and does not apply procedures for monitoring and inspections"
      },
      "psbP": {
        "score0": "Yes or free-overflow weir type spillway",
        "score6": "No"
      },
      "psbQ": {
        "score0": "Regularly issues the reports",
        "score3": "Issues the reports without periodicity",
        "score5": "Does not issue the reports"
      },
      "dpaA": {
        "score1": "Small: ≤ 5 million m³",
        "score2": "Medium: 5 million to 75 million m³",
        "score3": "Large: 75 million to 200 million m³",
        "score5": "Very large: > 200 million m³"
      },
      "dpaB": {
        "score0": "Nonexistent — there are no permanent/resident or temporary/transient people in the area affected downstream of the dam",
        "score4": "Infrequent — no people permanently occupy the affected area downstream of the dam, but there is a local access road",
        "score8": "Frequent — no people permanently occupy the affected area downstream of the dam, but there is a municipal, state or federal highway or another site and/or development of occasional presence of people who could be affected",
        "score12": "Existent — people permanently occupy the area affected downstream of the dam, therefore human lives could be affected"
      },
      "dpaC": {
        "score1": "Slightly significant — the affected area of the dam does not represent an environmental interest area, areas protected by specific legislation, or is fully stripped of its natural conditions",
        "score2": "Significant — the affected area includes sustainable-use protection areas (EPA, FLONA, RESEX, etc.) or is an environmental interest area and is slightly stripped of its natural conditions",
        "score5": "Very significant — the affected area includes full-protection areas (ESEC, PARNA, REBIO, etc.), including Indigenous Lands, or is of great environmental interest in its natural state"
      },
      "dpaD": {
        "score0": "Nonexistent — there are no facilities or navigation services in the area affected by a dam accident",
        "score1": "Low — there are residential and commercial, agricultural, industrial facilities or infrastructure in the affected area of the dam",
        "score3": "Medium — there are residential, agricultural, industrial facilities or infrastructure in the affected area of the dam",
        "score8": "High — there is a large concentration of residential, agricultural facilities, infrastructure and leisure and tourism services in the affected area of the dam, or port facilities or navigation services"
      }
    }
  }
} as const;
